import * as React from 'react'
import {
  List,
  TextField,
  ReferenceArrayField,
  FunctionField,
  SingleFieldList,
  DatagridConfigurable,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin'
import { Link } from 'react-router-dom'
import { BulkActionsOrders } from '../../utils/bulkProgressOrder'
import RefreshOrderButton from '../../utils/refreshOrdersButton'
import { OrderCustomerDetailField, OrderItemsField, OrderOutBoundShippingField, ProgressOrderActions, OrderToolTip } from '../fields/orderFields'
import Chip from '@mui/material/Chip'

const OrderList = (props) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const [loading, setLoading] = React.useState(false)
  const handleLoading = (bool) => setLoading(bool)

  const OrderFilters = [<TextInput label="Search" source="q" alwaysOn />]

  return (
    <List
      {...props}
      actions={
        <TopToolbar>
          <RefreshOrderButton setLoading={handleLoading} notify={notify} refresh={refresh} />
          <FilterButton />
          <SelectColumnsButton />
        </TopToolbar>
      }
      filter={{ _order: 'DESC' }}
      filters={OrderFilters}
    >
      <DatagridConfigurable isLoading={loading} bulkActionButtons={<BulkActionsOrders />}>
        <FunctionField
          label="OrderNum"
          render={(record) => <Link to={`/orders/${record.id}/show`}>{record.shopifyOrderNumber}</Link>}
        />
        <OrderToolTip label="Notes" />
        <FunctionField
          label="MFH Status"
          render={(record) => {
            if (record.status === 'new') {
              return <Chip label={record.status} color="success" />
            }
            return <Chip label={record.status} />
          }}
        />
        <OrderCustomerDetailField label="Customer" />
        <OrderItemsField label="Items" />
        <FunctionField
          label="Kit(s)"
          render={(record) =>
            Array.isArray(record?.kitIds) && record.kitIds.length > 0 ? (
              <ReferenceArrayField link="show" record={record} label="Kit(s)" source="kitIds" reference="kits">
                <SingleFieldList style={{ display: 'flex', flexFlow: 'column', rowGap: '10px' }}>
                  <TextField source="id" />
                </SingleFieldList>
              </ReferenceArrayField>
            ) : null
          }
        />
        <FunctionField
          label="PPKit(s)"
          render={(record) => {
            if (record.prepaidKitIds && record.prepaidKitIds.length)
              return (
                <span>
                  <b>{record.prepaidKitIds.length}</b>
                </span>
              )
          }}
        />
        <OrderOutBoundShippingField label="Outbound Shipping" />
        <ProgressOrderActions label="Actions" />
      </DatagridConfigurable>
    </List>
  )
}

export default OrderList
